module.exports = __webpack_public_path__ + "img/logo_no_symbol.203ddda6.png";